/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Intro_P2_StrongInputs */

const es_gift_intro_p2_strong = /** @type {(inputs: Gift_Intro_P2_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 meses`)
};

const gl_gift_intro_p2_strong = /** @type {(inputs: Gift_Intro_P2_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 meses`)
};

const en_gift_intro_p2_strong = /** @type {(inputs: Gift_Intro_P2_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 months`)
};

/**
* | output |
* | --- |
* | "6 months" |
*
* @param {Gift_Intro_P2_StrongInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_intro_p2_strong = /** @type {((inputs?: Gift_Intro_P2_StrongInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Intro_P2_StrongInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_intro_p2_strong(inputs)
	if (locale === "en") return en_gift_intro_p2_strong(inputs)
	return es_gift_intro_p2_strong(inputs)
});